import styled from 'styled-components'
import { BaseButton } from '../buttons'

export const UpButton = styled(BaseButton)<{ $size: number }>`
    width: ${(p) => p.$size}px;
    height: ${(p) => p.$size}px;
    border-radius: 50%;
    color: ${(p) => p.theme.colors.white};
    background-color: ${(p) => p.theme.colors.lightGrey};
    display: flex;
    align-items: center;
    justify-content: center;
    /* font-size: 10px; */
    line-height: ${(p) => p.$size}px;
    font-weight: bold;
    padding: 4px;
    box-sizing: content-box;

    &:hover {
        background-color: ${(p) => p.theme.colors.primaryGreen};
    }
`

export const DownButton = styled(UpButton)``

export const LeftButton = styled(UpButton)``

export const RightButton = styled(UpButton)``
